export const usersColumn = [
  {
    checkboxSelection: true,
    headerName: 'RolesManagement.UsersColumn.Username',
    headerTooltip: 'RolesManagement.UsersColumn.Username',
    field: 'username',
    colId: 'username',
    valueFormatter: ({ value }) => value ?? 'N/A',
    hide: false,
    flex: 1,
    filter: 'agTextColumnFilter',
    cellClass: 'modal-link-layout'
  },
  {
    headerName: 'RolesManagement.UsersColumn.Name',
    headerTooltip: 'RolesManagement.UsersColumn.Name',
    field: 'name',
    colId: 'name',
    valueFormatter: ({ value }) => value ?? 'N/A',
    hide: false,
    flex: 1,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.UsersColumn.Email',
    headerTooltip: 'RolesManagement.UsersColumn.Email',
    field: 'email',
    valueFormatter: ({ value }) => value ?? 'N/A',
    hide: false,
    flex: 1,
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'RolesManagement.UsersColumn.Role',
    headerTooltip: 'RolesManagement.UsersColumn.Role',
    field: 'roles',
    hide: false,
    flex: 1,
    minWidth: 300,
    valueFormatter: ({ value }) => value?.join(', ') ?? 'N/A',
    filter: 'agTextColumnFilter',
    cellStyle: { fontWeight: '900' }
  }
]
